import styled from "@emotion/styled";

export const ReplacementReasonsHeaderContainerWrapper = styled.div(({ theme }) => ({
	display: "flex",
	gap: "24px",
	width: "100%",
	backgroundColor: theme.project.colors.allColors.hex.grayscale.gray100,
	padding: "16px",
	boxSizing: "border-box",
	borderBottom: `1px solid ${theme.project.colors.allColors.hex.grayscale.gray300}`,
	"> div": {
		flex: 1
	},
	[theme.breakpoints.down("md")]: {
		flexDirection: "column",
		gap: "16px"
	}
}));

export const ReplacementReasonsHeaderContainerSkuWrapper = styled.div(({ theme }) => ({
	display: "flex",
	gap: "16px",
	"span:first-of-type": {
		...theme.project.typography.body.body1,
		color: theme.project.colors.fontColors.main
	}
}));

export const ReplacementReasonsHeaderContainerSku = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	marginTop: "-2px",
	"span:first-of-type": {
		...theme.project.typography.heading.h6
	},
	"span:last-of-type": {
		...theme.project.typography.body.body1,
		color: theme.project.colors.fontColors.secondary
	}
}));

// @ts-ignore
export const ReplacementReasonsHeaderContainerInfo = styled.div(({ theme }) => ({
	display: "flex",
	justfiyContent: "space-between",
	gap: "24px",
	div: {
		display: "flex",
		flexDirection: "column",
		color: theme.project.colors.fontColors.main,
		"span:first-of-type": theme.project.typography.subtitle.subtitle2,
		"span:last-of-type": {
			...theme.project.typography.body.body2,
			color: theme.project.colors.fontColors.secondary
		}
	},
	[theme.breakpoints.down("md")]: {
		flexDirection: "column",
		gap: "4px",
		div: {
			flexDirection: "row",
			gap: "8px",
			alignItems: "center"
		}
	}
}));
